import { AdhesionProductInterface } from '../../../../interfaces/dto/sales-portal/adhesion-product/adhesion-product-interface';
import { ContactsMethodModel, CountryInfoModel, CurrencyInfoModel, PaymentMethodInfoModel } from '@fh-client-interaction-frontends/fh-providers';

export class AdhesionProductModel implements AdhesionProductInterface {
  baseValue?: number;
  canSubscribe?: number;
  clinicalQuestionnaireContactMethods?: ContactsMethodModel[] = new Array<ContactsMethodModel>();
  contractDurationDays?: number;
  countryInfo?: CountryInfoModel[];
  currencyInfo?: CurrencyInfoModel[];
  description?: string;
  displayFracMonths?: number;
  displayType?: string;
  firstPaymentMethodInfo?: PaymentMethodInfoModel[];
  genProposalPdf?: number;
  genSimulationPdf?: number;
  hasAssociatedConsents?: boolean;
  htmlDescription?: string;
  maxPersons?: number;
  minFracInit?: number;
  minPersons?: number;
  paymentMethodInfo?: PaymentMethodInfoModel[];
  productUsageCondition?: string;
  sendPendingPaymentNotification?: boolean;
  sendProposalEmail?: number;
  sendSimulationEmail?: number;
  startDateMaxDayOfMonth?: number;
  startDateMaxDaysInFuture?: number;
  type?: string;
  uwGenQuestionnaire?: boolean;
  uwSubscribe?: boolean;
  signatureType?: string[];
  // client-portal unique properties below:
  name?:string;
  productId?:string;
  paymentMethods?: PaymentMethodInfoModel[];
  currency?:string;
  countryInfos?:CountryInfoModel[];

  constructor(init?: Partial<AdhesionProductModel>) {
    Object.assign(this, init);
  }
}
